'use client';

import { useCallback } from 'react';
import type { Behavior, Expression } from '@capture/shared';
import { extractDependencies } from '@capture/shared';
import { FormulaField } from '../../shared/FormulaField';

interface Props {
  behavior: Extract<Behavior, { kind: 'compute' }>;
  onChange: (b: Behavior) => void;
  fieldNames: string[];
  advanced: boolean;
  scope?: 'record' | 'batch';
}

export function ComputeBody({ behavior, onChange, fieldNames, scope }: Props) {
  const handleChange = useCallback(
    (next: Expression) => {
      const dependsOn = extractDependencies(next.source);
      onChange({ ...behavior, formula: { source: next.source }, dependsOn });
    },
    [behavior, onChange],
  );

  return (
    <FormulaField
      value={behavior.formula}
      onChange={handleChange}
      fieldNames={fieldNames}
      context="compute"
      scope={scope}
    />
  );
}
